{
  "sm": "640px",
  "md": "768px",
  "lg": "1024px",
  "xl": "1216px",
  "menu": "1320px",
  "menu-premium": "1245px",
  "2xl": "1600px"
}
